import React from 'react';
import {DownloadIcon, FileIcon} from '../../Components/Icons/Icons';
import { humanFileSize } from '~/helpers/utils';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

export default function Documents ({ guest }) {

	const passportDocs = guest?.documents?.filter(doc => doc.type === 'passport');
	const accreditationDocs = guest?.documents?.filter(doc => doc.type === 'accreditation');

	return (
		<div className="supporting-documents">
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="docs-passport" fallback="Passport" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					{
						passportDocs.map((single, index) => {
							return (
							<div key={`passport_doc_${index}`} className="doc col-12 p-0 mt-3 mt-lg-0">
								<div className="flex-gap align-items-center">
									<FileIcon />
									<p>{single.name}</p>
									<span className="file-size">{humanFileSize(single.size)}</span>
									{/* <a href={single.download_url}>
										<DownloadIcon/>
									</a> */}
								</div>
							</div>
							)
						})
					}

					{passportDocs.length === 0 && (
						<p>-</p>
					)}

				</div>
			</div>
			<hr />
			<div className="row">
				<div className="col-lg-4 col-12">
					<label><TextTranslate name="docs-accreditation-photo" fallback="Accreditation Photo" textOnly/></label>
				</div>
				<div className="col-lg-8 col-12">
					{
						accreditationDocs.map((single, index) => {
							return (
								<div key={`accreditation_doc_${index}`} className="doc col-12 p-0 mt-3 mt-lg-0">
									<div className="flex-gap align-items-center">
										<FileIcon />
										<p>{single.name}</p>
										<span className="file-size">{humanFileSize(single.size)}</span>
										{/* <a href={single.download_url}>
											<DownloadIcon/>
										</a> */}
									</div>
								</div>
							)
						})
					}

					{accreditationDocs.length === 0 && (
						<p>-</p>
					)}
				</div>
			</div>
		</div>
	)
}
